<script>
    import Menu from "./Menu.svelte";
    import HeaderInfo from "./MenuComponents/HeaderInfo.svelte";
    import Content from "./Content.svelte";
    import BookNow from "./MenuComponents/BookNow.svelte";
    import Images from "./MenuComponents/Images.svelte";
    import InfoTab from "./MenuComponents/InfoTab.svelte";

    let activeTab;

</script>

<div class="mobile-layout">
    <div class="flex-center main-div">
        <div class="flex-column header-menu" style="justify-content: {activeTab === 'schedule' ? 'space-between' : 'flex-start'}">
            <HeaderInfo activeTab={activeTab}/>
            <Content activeTab={activeTab}/>
        </div>
        <Menu bind:activeTab={activeTab}/>
    </div>
</div>

<div class="desktop-layout">
    <div class="flex-center main-div">
        <div class="flex-column header-menu">
            <HeaderInfo/>
            <BookNow/>
            <Images/>
            <InfoTab/>
        </div>
    </div>
</div>

<style>
    .mobile-layout {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .desktop-layout {
        display: none;
    }
    @media screen and (min-width: 769px) {
        .mobile-layout {
            display: none;
        }
        .desktop-layout {
            display: block;
            margin: 0 auto;
            width: 100%;
        }
    }
    .header-menu{
        width:100%;
    }
    .flex-column{
        display: flex;
        flex-direction: column;
        border-radius: 5px;
        flex-grow: 1;
    }
    .main-div{
        display:flex;
        flex-direction: column;
        height:100%;
        justify-content: space-between;
    }
    .flex-center{
        height: 100dvh;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    @media screen and (max-width: 768px) {
        .main-div{
            width:100%;
        }
    }

</style>
